import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import { Link } from '@material-ui/core';

export default function HeaderNew({ SFMediaSubmissionID }) {
  return (
    <AppBar className="new-header">
      <Link href="#">
        <img src={'../logo.svg'} alt="Media Uploader" />
      </Link>

      <div>
        <h2>Media Uploader.</h2>
      </div>
      <div className="new-header-right">
        <p>ID:{SFMediaSubmissionID}</p>
      </div>
    </AppBar>
  );
}
